export const features1 = {
  id: 'about',
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Premium Wallet',
  headline: 'Our wallet is built for the cryptocurrency beginner',
  // headline: 'Unlimited crypto exchanges with zero fees',
  description:
    'Get access to our exclusive app that allows you to send unlimited transactional without getting any trouble.',
  buttonLabel: 'Get Stared',
  imgStart: false,
  img: require('assets/images/currency-exchange.svg'),
  alt: 'Crypto Wallet',
  dark: false,
  primary: true,
  darkText: false
};

export const features2 = {
  id: 'discover',
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Premium Wallet',
  headline: 'Privacy preserving anonymous fund protocol',
  // headline: 'Login to your account at any time',
  description:
    'We have you covered no matter where you are located. All you need is an internet connection and a phone or computer',
  buttonLabel: 'Learn More',
  imgStart: true,
  img: require('assets/images/account.svg'),
  alt: 'account',
  dark: false,
  primary: false,
  darkText: true
};

export const features3 = {
  id: 'wallet',
  lightBg: true,
  invertText: true,
  lightText: false,
  lightTextDesc: true,
  topLine: 'Premium Wallet',
  headline: 'Creating an crypto wallet is extremely easy',
  description:
    "Get everything set up and ready in under 10 minutes. All you need to do is add your information and you're ready to go.",
  buttonLabel: 'Start Now',
  imgStart: false,
  img: require('assets/images/wallet.svg'),
  alt: 'paying',
  dark: false,
  primary: true,
  darkText: true
};
